import { EntityLookupModel } from "./entity-lookup.model";
import { SearchGlobalModel } from "./search-global.model";
import { ZendeskArticleModel } from "./zendesk-article.model";

export namespace DataFlattenerWorkerModel {

  export type WorkerMessageType = 'RUN_FLATTEN' | 'RUN_FLATTEN_SUCCESS' | 'RUN_FLATTEN_FAIL' | 'RUN_CANCEL_FLATTEN' | 'WORKER_PING' | 'WORKER_READY';
  type RunFlattenType = Extract<WorkerMessageType, 'RUN_FLATTEN'>;
  type RunFlattenSuccessType = Extract<WorkerMessageType, 'RUN_FLATTEN_SUCCESS'>;
  type RunFlattenFailType = Extract<WorkerMessageType, 'RUN_FLATTEN_FAIL'>;
  type RunCancelFlattenType = Extract<WorkerMessageType, 'RUN_CANCEL_FLATTEN'>;
  type WorkerPingType = Extract<WorkerMessageType, 'WORKER_PING'>;
  type WorkerReadyType = Extract<WorkerMessageType, 'WORKER_READY'>;

  export interface FlattenData {
    dataType: 'location' | 'event' | 'wall' | 'alarm' | 'people' | 'floor' | 'article';
    locations?: any[], // LocationModel.LocationItem[],
    events?: any[], //EventV2Document[],
    entityLookup?: EntityLookupModel.EntityLookupMap,
    walls?: any[] //WallV2Model.WallMongoDocument[]
    home?: any[] // HomeModel.Location[]
    alarms?: any[] // AlarmModel.AlarmDocument[]
    people?: any[] // AlarmModel.AlarmDocument[]
    floors?: any[] // AlarmModel.AlarmDocument[]
    articles?: ZendeskArticleModel.ZendeskArticleRaw[];
  }

  export interface RunFlattenMessage extends FlattenData {
    type: RunFlattenType;
    requestId: string;
  }

  export interface RunFlattenSuccessMessage {
    type: RunFlattenSuccessType;
    requestId: string;
    searchableItems: SearchGlobalModel.SearchableItem[],
    cameraUpdates?: {id: string, changes: {floors: any[], buildings: any[]}}[];
  }

  export interface RunFlattenFailMessage {
    type: RunFlattenFailType;
    requestId: string;
    error: any;
  }

  export interface RunFlattenCancelMessage {
    type: RunCancelFlattenType;
    requestId: string;
  }

  export interface WorkerPingMessage {
    type: WorkerPingType;
    requestId: string;
  }

  export interface WorkerReadyMessage {
    type: WorkerReadyType;
    requestId: string;
  }

  export function isRunFlattenSuccessMessage(
    msg: FlattenWorkerMessage
  ): msg is RunFlattenSuccessMessage {
    return msg.type === 'RUN_FLATTEN_SUCCESS';
  }

  export function isRunFlattenFailMessage(
    msg: FlattenWorkerMessage
  ): msg is RunFlattenFailMessage {
    return msg.type === 'RUN_FLATTEN_FAIL';
  }

  export function isWorkerReadyMessage(
    msg: FlattenWorkerMessage
  ): msg is WorkerReadyMessage {
    return msg.type === 'WORKER_READY';
  }

  export type FlattenWorkerMessage =
    | RunFlattenMessage
    | RunFlattenSuccessMessage
    | RunFlattenFailMessage
    | RunFlattenCancelMessage
    | WorkerPingMessage
    | WorkerReadyMessage;


  export interface WorkerMessage {
    locations: [], // LocationModel.LocationItem[],
    events: [], //EventV2Document[],
    entityLookup: EntityLookupModel.EntityLookupMap,
    walls: [] //WallV2Model.WallMongoDocument[]
  }

}


